import { render, staticRenderFns } from "./GroupsCoordinator.vue?vue&type=template&id=6c061b6b&scoped=true&"
import script from "./GroupsCoordinator.vue?vue&type=script&lang=js&"
export * from "./GroupsCoordinator.vue?vue&type=script&lang=js&"
import style0 from "./GroupsCoordinator.vue?vue&type=style&index=0&id=6c061b6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c061b6b",
  null
  
)

export default component.exports